import { atom } from 'jotai';
import {configurationType} from "@/lib/definitions/definitions";

export const configurationState = atom<configurationType>({
    config: {
        activeOptions: {
            ASSISTANT: null,
            SSO: []
        }
    },
    events: null,
    activeTemplates: null,
    envVars: {
        title: undefined,
        origin: undefined,
        apiHost: undefined,
        key: undefined,
        secret: undefined,
        client: undefined
    }
});
